/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PunchoutDetails
 */
export interface PunchoutDetails {
    /**
     * 
     * @type {boolean}
     * @memberof PunchoutDetails
     */
    isPunchoutEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PunchoutDetails
     */
    isPunchoutSessionActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PunchoutDetails
     */
    procurementAppName?: string;
    /**
     * 
     * @type {string}
     * @memberof PunchoutDetails
     */
    procurementAppUrl?: string;
}

/**
 * Check if a given object implements the PunchoutDetails interface.
 */
export function instanceOfPunchoutDetails(value: object): value is PunchoutDetails {
    return true;
}

export function PunchoutDetailsFromJSON(json: any): PunchoutDetails {
    return PunchoutDetailsFromJSONTyped(json, false);
}

export function PunchoutDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PunchoutDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'isPunchoutEnabled': json['isPunchoutEnabled'] == null ? undefined : json['isPunchoutEnabled'],
        'isPunchoutSessionActive': json['isPunchoutSessionActive'] == null ? undefined : json['isPunchoutSessionActive'],
        'procurementAppName': json['procurementAppName'] == null ? undefined : json['procurementAppName'],
        'procurementAppUrl': json['procurementAppUrl'] == null ? undefined : json['procurementAppUrl'],
    };
}

export function PunchoutDetailsToJSON(value?: PunchoutDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isPunchoutEnabled': value['isPunchoutEnabled'],
        'isPunchoutSessionActive': value['isPunchoutSessionActive'],
        'procurementAppName': value['procurementAppName'],
        'procurementAppUrl': value['procurementAppUrl'],
    };
}

